import invariant from 'tiny-invariant';

import { client as apolloClient } from 'src/shared/graphql';
import type { JobThreeDFiles } from 'src/shared/graphql/generated';
import { queries } from 'src/shared/graphql/requests';

const fetchUrls = async (jobId: number, modelId: number) => {
  const { data } = await queries.getJob(apolloClient, { id: jobId });
  const jobResult = data.jobs.results[0];
  const model = jobResult?.models?.find(m => m.id === modelId);
  invariant(model, 'Model not found');
  const threeDFiles = model?.threeDFiles;

  return threeDFiles as JobThreeDFiles;
};

export { fetchUrls };
